export default "__VITE_ASSET__c51db293__"